import { SVGProps } from 'react'

const ChevronDownIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width='17' height='16' viewBox='0 0 17 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
            <path
                d='M4.25 6L8.25 10L12.25 6'
                stroke='#959699'
                strokeWidth='1.33333'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export default ChevronDownIcon
